module.exports = __webpack_public_path__ + "static/appearance@2x-5bda12ced04502543ea7833193f7a3fc.png";